<template>
  <div class="item-list">
    <el-row :gutter="20">
      <div v-for="item in itemList" :key="item.id">
        <el-col :span="12">
          <div class="item">
            <el-col :span="item.pubimg?17:23" style="line-height:120%">
              <span class="item-title">{{ item.title }}</span>
              <p style="margin-top:5px" class="item-detail">
                <span v-for="(author, index) in item.authors.split(',').slice(0, 3)" :key="author.id">
                  {{ author }}<span v-if="!(index===item.authors.split(',').slice(0, 3).length-1)">,</span>
                </span>
                <span v-if="item.authors.split(',').length > 3">, <i>et al.</i></span><br>
              </p>
              <el-divider style="margin:0px" />
              <p class="item-detail">
                {{ new Date(item.publishTime).toLocaleDateString().split('/').join('-') }}
                <el-divider direction="vertical" />
                <span style="color:#303133;font-weight:520"><i>{{ item.journal }}</i></span>
              </p>
              <div style="margin-top:15px">
                <div style="display:inline-block" @click="handleVisit(item.id)">
                  <el-link style="font-size:15px" target="_blank" :disabled="item.url?false:true" :href="item.url" type="primary">Detail</el-link>
                </div>
                <span style="font-size:13px;color:#909399;margin-left:5px">( {{ item.visitCount }} )</span>
                <!-- <el-button style="margin-left:10px;padding:0px" size="mini" type="text" @click="handleDownload(item.id)">
                  <el-link type="primary" :disabled="item.filename?false:true" :href="nginxURL + UPLOAD_PATH['articlepdf'] + item.filename" target="_blank">Download Link</el-link>
                </el-button>
                <span v-if="item.filename" style="font-size:13px;color:#909399;margin-left:5px">( {{ item.downloadCount }} )</span> -->
                <span v-if="item.citenum" class="tag cite"> CITE {{ item.citenum }}</span>
                <span v-if="item.ifnum" class="tag if"> IF {{ item.ifnum }}</span>
              </div>
            </el-col>
            <el-col v-if="item.pubimg" :span="7">
              <div>
                <el-image
                  class="item-img"
                  :src="nginxURL + UPLOAD_PATH['articlecover'] + item.pubimg"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-tickets" />
                  </div>
                </el-image>
              </div>
            </el-col>
          </div>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import { nginxURL, UPLOAD_PATH } from '../../../utils/constants'

export default {
  props: ['itemList'],
  data() {
    return {
      nginxURL,
      UPLOAD_PATH
    }
  },
  methods: {
    async handleVisit(id) {
      await this.$http.get('/api/pub/visit?id=' + id)
        .then((res) => {
          window.location.reload()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async handleDownload(id) {
      await this.$http.post('/api/pub/download', { id })
        .then((response) => {
          window.location.reload()
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
.item-img {
  width: 100%;
  height: 100px;
  object-fit:cover;
}
.tag {
    margin-left: 10px;
    color: #fff;
    padding: 2px;
    border-radius: 15px;
    /* font-weight: 550; */
    font-size: 12px;
    line-height: 100%;
    padding-left: 4px;
    padding-right: 4px;
    font-weight: 550;
}
.cite {
    display: inline-block;
    background: #67C23A;
    line-height: 100%;
}
.if {
    display: inline-block;
    background: #F56C6C;
}
.item-detail {
    font-size: 14px;
    color:#909399;
}
.el-divider--horizontal {
        margin: 5px 0;
}
.item-title {
    font-size:15px;
    font-weight: 550;
}
.item-author {
    font-size: 14px;
}
.item {
     border:1px solid #E4E7ED;
     height: 190px;
     margin: 15px 10px 15px 10px;
     background-color: #fff;
     border-radius: 20px;
     padding: 20px 0px 15px 10px;
     box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
.item-img {
    height: 80%;
    /* padding: 15px; */
    /* margin-top: 20px; */
  }
* {
    text-align:justify;
}
</style>
